import DataTable from 'src/shared/components/table';
import TableColumns from './columns';
import useTableV2 from 'src/shared/hooks/useTableV2';
import {ICampaignHistory} from 'src/shared/services/campaigns/dto/campaign-list';
import {useParams} from 'react-router-dom';
import {useGetCampaignsHistory} from '../../hooks/useGetCampaignHistory';

function HistoryOfSentEmails() {
  const {id} = useParams();
  const {showTotal, ...tableV2} = useTableV2();
  const {data, isLoading} = useGetCampaignsHistory(id ?? '');

  return (
    <DataTable
      columns={TableColumns()}
      dataSource={data?.Data}
      rowKey={(record: ICampaignHistory) => record?.SentDate?.toString()}
      loading={isLoading}
      border
      tableProps={tableV2}
    />
  );
}

export default HistoryOfSentEmails;
